module.exports = __webpack_public_path__ + "static/media/season_earnings.72963143.png";